import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import PageHero from "../components/child/PageHero";
import MessageLogLayer from "../components/MessageLogLayer";

const MessageLogList = () => (
  <MasterLayout>
    <PageHero
      title="Message Logs"
      subtitle="Track delivered, queued, and failed messages with live updates."
      badge={{ icon: "mdi:clipboard-text-clock-outline", label: "Live" }}
    />
    <MessageLogLayer />
  </MasterLayout>
);

export default MessageLogList;
